import ajax from "@/lib/ajax";


// Patient/GetPatientOutComeList
// 查询患者转归记录
export async function GetPatientOutComeList(payload: any){
	let res = await ajax.get('/api/services/app/Patient/GetPatientOutComeList', {params:payload})
	return res.data.result
}
// Patient/InsertPatientOutCome
// 患者转归新增
export async function InsertPatientOutCome(payload: any){
	let res = await ajax.post('/api/services/app/Patient/InsertPatientOutCome', payload)
	return res.data.result
}
// Patient/EditPatientOutCome
// 患者转归编辑
export async function EditPatientOutCome(payload: any){
	let res = await ajax.post('/api/services/app/Patient/EditPatientOutCome', payload)
	return res.data.result
}


// HdPre/CreatePatTScheme
// 新增治疗方案
export async function CreatePatTScheme(payload: any){
	let res = await ajax.post('/api/services/app/HdPre/CreatePatTScheme', payload)
	return res.data.result
}
// HdPre/OperatePatTScheme
// 停用/删除治疗方案
export async function OperatePatTScheme(payload: any){
	let res = await ajax.post('/api/services/app/HdPre/OperatePatTScheme', payload)
	return res.data.result
}
// HdPre/GetPatTSchemes
// 查询治疗方案
export async function GetPatTSchemes(payload: any){
	let res = await ajax.get('/api/services/app/HdPre/GetPatTSchemes', {params:payload})
	return res.data.result
}
// HdPre/GetPatPreTemps
// 查询处方模板列表
export async function GetPatPreTemps(payload: any){
	let res = await ajax.get('/api/services/app/HdPre/GetPatPreTemps', {params:payload})
	return res.data.result
}
// DeletePatPreTemp
// 删除处方模板
export async function DeletePatPreTemp(payload: any){
	let res = await ajax.delete('/api/services/app/HdPre/DeletePatPreTemp', {params:payload})
	return res.data.result
}
// HdPre/LoadPatPreTemp
// 加载患者处方模板数据
export async function LoadPatPreTemp(payload: any){
	let res = await ajax.get('/api/services/app/HdPre/LoadPatPreTemp', {params:payload})
	return res.data.result
}
// GetPatientList
// 获取所有患者
export async function GetPatientList(){
	let res = await ajax.get('/api/services/app/Patient/GetPatientList')
	return res.data.result
}
// HdPre/SavePatPreTemp
// 新增/编辑处方模板列表
export async function SavePatPreTemp(payload: any){
	let res = await ajax.post('/api/services/app/HdPre/SavePatPreTemp', payload)
	return res.data.result
}

// HdPre/CreatePatSTScheme
// 新增治疗方案
export async function CreatePatSTScheme(payload: any){
	let res = await ajax.post('/api/services/app/HdPre/CreatePatSTScheme', payload)
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/patient/index.ts